import { gql } from '@apollo/client';

export const GET_DAILY_SALES_ACTIVITY = gql(/* GraphQL */ `
    query GetDailySalesActivity($userId: String!, $days: Int) {
        getDailySalesActivity(userId: $userId, days: $days) {
            userId
            firstName
            lastName
            role
            storeNumber
            storeName
            divisionName
            activity {
                date
                reviewed
                firstReviewedAt
                firstReviewedSource
            }
            totalDays
            reviewedDays
            missedDays
        }
    }
`);
